import { useCallback, useRef, useState, useEffect } from "react";
import { Space, Input, Select, Button, Modal, message } from "antd";
import "./index.styl";
import {
  getMainModuleList,
  getChildModuleList,
  getRoleList,
} from "../../../api/common";
import { createJob } from "../../../api/departmentJob";

const { TextArea } = Input;

export default function ModuleRoleAdd() {

  // 主模块
  const [mainModuleData, setMainModuleData] = useState([]);
  const [defaultMainModuleKey, setDefaultMainModuleKey] = useState("");
  const [defaultMainModuleName, setDefaultMainModuleName] = useState("");

  // 子模块
  const [childModuleData, setChildModuleData] = useState([]);
  const [defaultChildModuleKey, setDefaultChildModuleKey] = useState("");
  const [defaultChildModuleName, setDefaultChildModuleName] = useState("");

  //自然村
  const [countrysideData, setCountrysideData] = useState([]);
  const [defaultCountrysideKey, setDefaultCountrysideKey] = useState("");
  const [countryVisible, setCountryVisible,] = useState(false);

  //角色名
  // const jobName = useRef('');
  // const onJobNameChanged = useCallback((e) => {
  //   jobName.current = e.target.value;
  // }, []);
  const [jobName, setjobName] = useState("");
  const onJobNameChanged = (e) => {
    //console.log(e.target.value);
    setjobName(e.target.value);
  }
  //支付单位
  // const paymentFrequency = useRef(0);
  // const onPaymentFrequencyChanged = useCallback((id, option) => {
  //   paymentFrequency.current = id;
  // }, []);
  const [paymentFrequency, setpaymentFrequency] = useState(-1);
  const onPaymentFrequencyChanged = (e) => {
    setpaymentFrequency(e);
  }


  //岗位标准
  // const beanAmount = useRef(0);
  // const onbeanAmountChanged = useCallback((e) => {
  //   beanAmount.current = e.target.value;
  // }, []);
  const [beanAmount, setbeanAmount] = useState('');
  const onbeanAmountChanged = (e) => {
    setbeanAmount(e.target.value);
  }

  //岗位介绍
  // const description = useRef('');
  // const onDescriptionChanged = useCallback((e) => {
  //   description.current = e.target.value;
  // }, []);

  const [description, setdescription] = useState('');
  const onDescriptionChanged = (e) => {
    setdescription(e.target.value);
  }

  const clearValue = function () {
    setdescription('');
    setbeanAmount('');
    setpaymentFrequency(-1);
    setjobName('');
  }

  const addJob = async () => {
    let departId = defaultChildModuleKey;
    console.log("调试" + defaultChildModuleKey);
    console.log("调试" + defaultCountrysideKey);
    if (defaultCountrysideKey != "" && defaultCountrysideKey != 0) {
      departId = defaultCountrysideKey;
    }
    console.log("调试" + departId);
    const data = {
      bean_amount: beanAmount,
      department_id: departId,
      description: description,
      job_name: jobName,
      payment_frequency: paymentFrequency
    };
    console.log(data);
    //{bean_amount: 0, department_id: undefined, description: 0, job_name: '', payment_frequency: 0}

    if (data.bean_amount === 0 || data.department_id == undefined || data.department_id == 0 ||
      data.description === '' || data.job_name === '' || data.payment_frequency == '-1') {
      message.error('请先把资料输入完整');
      return;
    }

    if (data.bean_amount <= 0) {
      message.error('智慧豆不能小于0');
      return;
    }

    const res = await createJob(data);

    console.log(res);
    if (res.code == 0) {
      setIsModalOpen(false);
      message.success('添加成功');
      clearValue();
    } else if (res.code == 555) {
      if (res.info.indexOf('job.name_department_id') != -1) {
        message.error('岗位角色名不能重复');
      } else {
        message.error('请重新添加');
      }
    }

  };

  // 获取主模块数据(在组件挂载时执行)
  useEffect(() => {
    async function fetchMainModuleList() {
      const mainModuleList = [{ id: 0, name: "全部" }];
      const res = await getMainModuleList();
      if (res?.code == 0 && res?.data?.length > 0) {
        mainModuleList.push(...res.data);
      }
      setMainModuleData(mainModuleList);
      setDefaultMainModuleKey(mainModuleList[0].id);
    }

    fetchMainModuleList();
  }, []);

  // 选择主模块item
  const onMainModuleItemSelected = async (id, option) => {
    const newChildModuleData = [{ id: "0", name: "全部" }];
    const newRoleData = [{ id: "0", name: "全部" }];
    if (id > "") {
      const res = await getChildModuleList({ main_depart_id: id });
      if (res.code == 0 && res.data?.length > 0) {
        newChildModuleData.push(...res.data);
      }
    }

    setDefaultMainModuleKey(id);
    setDefaultMainModuleName(option.name);
    setChildModuleData(newChildModuleData);
    setDefaultChildModuleKey(newChildModuleData[0].id);
  };

  // 选择子模块
  const onChildModuleItemSelected = async (id, option) => {
    //选择自然村的情况下加载自然村的数据
    setDefaultChildModuleKey(id);
    setDefaultChildModuleName(option.name);

    const newCountrysideData = [{ id: "0", name: "全部" }];
    setCountryVisible(false);
    if (id == 11) {//  11是初始化数据里自然村的编号id
      setCountryVisible(true);
      try {
        const resC = await getChildModuleList({ main_depart_id: id }); //自然村数据
        console.log("res+_+_", resC);
        if (resC.code == 0 && resC.data?.length > 0) {
          newCountrysideData.push(...resC.data);
        }
      } catch (error) {
        console.log(error);
      }
    }

    setCountrysideData(newCountrysideData);
    setDefaultCountrysideKey(newCountrysideData[0].id);

  };


  // 选择自然村
  const onCountrysideItemSelected = async (id, option) => {
    setDefaultCountrysideKey(id);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onCreateClick = () => {
    showModal();
  };

  return (
    <div className="roleAddPage">
      <Space
        direction='vertical'
        align='start'
        size='middle'
      >
        <Space>
          <span className="leftTitle">请选择板块：</span>
          <Select
            value={defaultMainModuleKey}
            style={{ width: 180 }}
            fieldNames={{ label: "name", value: "id" }}
            onChange={onMainModuleItemSelected}
            options={mainModuleData}
          />
        </Space>

        <Space>
          <span className="leftTitle">选择子板块：</span>
          <Select
            value={defaultChildModuleKey}
            style={{ width: 180 }}
            fieldNames={{ label: "name", value: "id" }}
            onChange={onChildModuleItemSelected}
            options={childModuleData}
          />
        </Space>
        {countryVisible ? (
          <Space>
            <span  className="leftTitle">自然村:</span>
            <Select
              value={defaultCountrysideKey}
              style={{ width: 180 }}
              fieldNames={{ label: "name", value: "id" }}
              onChange={onCountrysideItemSelected}
              options={countrysideData}
            />
          </Space>

        ) : null}
        <Space>
          <span className="leftTitle">创建任务角色：</span>
          <Input
            style={{
              width: 200,
            }}
            onChange={onJobNameChanged}
            placeholder="请输入角色名称"
            value={jobName}
          />
        </Space>
        <Space>
          <span className="leftTitle">标准智慧豆：</span>
          <Input
            style={{
              width: 160,
            }}
            placeholder="请输入智慧豆"
            onChange={onbeanAmountChanged}
            value={beanAmount}
          />
          <Select
            style={{
              width: 100,
            }}
            placeholder="选择单位"
            onChange={onPaymentFrequencyChanged}
            options={[{ value: -1, label: '请选择' }, { value: '0', label: '次' }, { value: '1', label: '月' }]}
            fieldNames={{ label: "label", value: "value" }}
            //defaultValue={-1}
            value={paymentFrequency}
          />
        </Space>
        <Space>
          <span className="leftTitle">岗位介绍：</span>

          <TextArea
            className="postInfo"
            placeholder="请输入岗位信息"
            autoSize={{
              minRows: 6,
              maxRows: 6,
            }}
            style={{ width: 270, }}
            onChange={onDescriptionChanged}
            value={description}
          />
        </Space>
        <div className="createButton">
          <Button
            type="primary"
            style={{ width: 160, }}
            onClick={onCreateClick}
          >创建
          </Button>
        </div>

      </Space>
      <Modal title="创建岗位角色"
        open={isModalOpen}
        onOk={addJob}
        onCancel={handleCancel}
        cancelText='取消'
        okText='确定'
      >
        <p>板块：{defaultMainModuleName}</p>
        <p>子版块：{defaultChildModuleName}</p>
        <p>任务角色：{jobName}</p>
        <p>岗位标准：每{paymentFrequency == 0 ? '次' : '月'}{beanAmount}个智慧豆</p>
        <p>岗位介绍：{description}</p>
      </Modal>
    </div>
  );
}
